const jwt = require('jsonwebtoken');
const config = require('../../config');

const { secretKey } = config;

const encrypt = value => {
  return jwt.sign(value, secretKey);
};

const decrypt = token => {
  return jwt.verify(token, secretKey);
};

export { encrypt, decrypt };
